import type { PlaceCardData } from '../../lib/conversationsApi';
import './placeListCard.css';
import { PlacePhoto } from './PlacePhoto';

export function PlaceListCard({ places }: { places: PlaceCardData[] }) {
  return (
    <section className="ozira-place-list" aria-label="Nearby places">
      <div className="ozira-place-list__brand"><span>OZIRA Live</span><strong>Google Maps</strong><span className="ozira-place-list__verified">Verified</span></div>
      <ul className="ozira-place-list__items">
        {places.map((place, index) => (
          <li className="ozira-place-list__item" key={`${place.name}-${place.latitude}-${place.longitude}-${index}`}>
            {place.photoUrl ? (
              <PlacePhoto key={place.photoUrl} className="ozira-place-list__photo" url={place.photoUrl} name={place.name} />
            ) : (
              <div className="ozira-place-list__pin" aria-hidden="true">●</div>
            )}
            <div className="ozira-place-list__body">
              {place.type ? <p className="ozira-place-list__type">{place.type}</p> : null}
              <h4>{place.name}</h4>
              <p>{place.address}</p>
            </div>
            <a className="ozira-place-list__link" href={place.mapsUrl} target="_blank" rel="noreferrer">Open</a>
          </li>
        ))}
      </ul>
      <p className="ozira-place-list__attribution" translate="no">Google Maps</p>
    </section>
  );
}
